export enum CardSize {
    SMALL = "small",
    LARGE = "large",
}

export enum DropDirection {
    DOWN = "down",
    UP = "up",
}

export enum HeadingVariant {
    DARK = "dark",
    LIGHT = "light",
}

export enum ButtonVariant {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    BACK = "back",
    SHARE = "share",
    EXIT = "exit",
    EDIT = "edit",
    DOWNLOAD = "downloadData",
    SAVE = "save",
}

export const HeadingColors: Record<HeadingVariant, string> = {
    [HeadingVariant.DARK]: "text-primary-400",
    [HeadingVariant.LIGHT]: "text-white",
};
